<template>
  <el-button class="manager-query-button" type="primary" native-type="submit" :disabled="disabled">查询</el-button>
</template>

<script>
import Button from 'element-ui/lib/button'
import 'element-ui/lib/theme-chalk/button.css'

export default {
  name: 'ManagerQueryButton',
  components: { 'el-button': Button },
  props: { disabled: Boolean }
}
</script>

<style scoped>
.manager-query-button.el-button {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  flex:0 0 80px;
  width:80px;
  min-width:80px;
  height:40px;
  min-height:40px;
  margin:0;
  padding:0;
  border:1px solid #237f78;
  border-radius:5px;
  color:#fff;
  background:#237f78;
  font-family:inherit;
  font-size:13px;
  font-weight:500;
  line-height:1;
  letter-spacing:0;
}
.manager-query-button.el-button:hover:not(:disabled) { border-color:#1b6e68; background:#1b6e68; }
.manager-query-button.el-button:focus-visible { outline:2px solid #237f78; outline-offset:2px; }
.manager-query-button.el-button:disabled { border-color:#237f78; color:#fff; background:#237f78; opacity:.55; cursor:not-allowed; }
</style>
